
class Formats {
    static DATE_FORMAT = 'YYYY-MM-DD';
    static TIME_FORMAT = 'HH:mm:ss';
}

export default Formats